export default {"src":"/_next/static/media/economics.59261ac3.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};